<template>
  <div>
    <c-auto-breadcrumbs class="px-6 h-12 flex content-center" />
    <q-separator />
  </div>
</template>
